var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"family-balances"},[_vm._v(" "+_vm._s(_vm.$t('CP.wholeFamily'))+": "),_c('money-message',{attrs:{"money-amount":_vm._f("toTwoFixed")(_vm.balance),"type":_vm.getPayoutType,"currency":_vm.currency}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }